import React from 'react';
import { Box } from '@mui/material';
import { Button, Drawer } from '../../../../../../../ui';

interface ISelectQuestions {
  isOpen: boolean;
  onCloseDrawer: () => void;
}

export const SelectQuestions: React.FC<ISelectQuestions> = ({
  isOpen,
  onCloseDrawer,
}) => {
  return (
    <Drawer
      isOpen={isOpen}
      onClose={onCloseDrawer}
      footerContent={
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, width: '100%' }}>
          <Button label="Cancel" onClick={onCloseDrawer} variant="secondary" />
          <Button label="Create" onClick={() => {}} variant="primary" />
        </Box>
      }
      title="Select Question"
      width="w-full md:w-1/3"
    >
      <></>
    </Drawer>
  );
};

export default SelectQuestions;
